import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import moment from 'moment';

// constants
import { layerTypes } from 'constants/advanced';

// utils
import { formatHistoryRowsBySeason } from '../harvestHistoryUtil';

// components
import HistoryHeader from './HistoryHeader';
import HistoryCciRow from './HistoryCciRow';
import HistoryYieldRow from './HistoryYieldRow';

const baseString = 'vra-history-multi-season-table';
const classString = classNames({
  [`${baseString}`]: true
});

const HistoryTable = ({
  cropList,
  displayHarvestDate=false,
  historyRows,
  isAppMode,
  onSelectCropForSeason,
  onSelectDateForSeason,
  onToggleLayerInclusion
}) => {
  const rowsBySeason = formatHistoryRowsBySeason(historyRows);
  const rowComponents = Object.entries(rowsBySeason).map(([key, values]) => {
    const layers = values.map(row => row.layerType === layerTypes.YIELD
      ? (
        <HistoryYieldRow
          averageYield={row.averageYield}
          cropName={get(row, 'crop.name', '')}
          cropNominalWeight={get(row, 'crop.cropNominalWeight')}
          date={row.date}
          displayHarvestDate={displayHarvestDate}
          isIncluded={row.isIncluded}
          key={`${layerTypes.YIELD}-${row.season}`}
          layerType={row.layerType}
          onToggleLayerInclusion={onToggleLayerInclusion}
          season={row.season}
        />)
      : (
        <HistoryCciRow
          cropList={cropList}
          date={row.date}
          displayHarvestDate={displayHarvestDate}
          isAppMode={isAppMode}
          isIncluded={row.isIncluded}
          key={`${layerTypes.CCI}-${row.season}`}
          layerType={row.layerType}
          onSelectCrop={(cropName) => {
            const selectedCrop = Object.values(cropList).find(crop => {
              return crop.name === cropName;
            });
            onSelectCropForSeason({season: row.season, cropId: Number(selectedCrop.id)});
          }}
          onSelectDate={(date) => {
            const newDate = moment(date).format('YYYY-MM-DD');
            onSelectDateForSeason({season: row.season, date: newDate});
          }}
          onToggleLayerInclusion={onToggleLayerInclusion}
          season={row.season}
          selectedCropId={row.selectedCropId}
        />
      )
    );
    return (
      <div key={key}>
        <div className={`${baseString}--season`}>{key}</div>
        {layers}
      </div>
    );
  });

  return (
    <table className={classString}>
      <thead>
        <HistoryHeader />
      </thead>
      <tbody>
        {rowComponents}
      </tbody>
    </table>
  );
};

HistoryTable.propTypes = {
  cropList: propTypes.object.isRequired,
  displayHarvestDate: propTypes.bool,
  historyRows: propTypes.array.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onSelectCropForSeason: propTypes.func.isRequired,
  onSelectDateForSeason: propTypes.func.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired
};

export default HistoryTable;
